import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import AssignPhoneCallDialog, {
  AssignPhoneCallDialogCallbackInput,
  AssignPhoneCallUniqueProps,
} from '../assignPhoneCallDialog';

const { useDialogForContext, useDialog: useAssignPhoneCallDialog } =
  getDialogHooks<
    AssignPhoneCallUniqueProps,
    AssignPhoneCallDialogCallbackInput
  >(AssignPhoneCallDialog);
export const useAssignPhoneCallDialogForContext = useDialogForContext;
export default useAssignPhoneCallDialog;
